interface CommentIconProps {
  color?: string;
  width?: string;
  height?: string;
  ref?: React.RefObject<HTMLDivElement>;
}

const CommentIcon = ({
  color = "#0056D6",
  width = "20",
  height = "20",
  ref,
}: CommentIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.18056 7.32639H10M6.18056 10H12.2917M6.18056 14.5833V16.3674C6.18056 16.7744 6.18056 16.978 6.26399 17.0825C6.33656 17.1734 6.44659 17.2263 6.56291 17.2262C6.69666 17.226 6.85558 17.0989 7.17343 16.8446L8.99565 15.3868C9.36789 15.089 9.55402 14.9401 9.76127 14.8342C9.94515 14.7403 10.1409 14.6716 10.3432 14.6301C10.5711 14.5833 10.8095 14.5833 11.2862 14.5833H13.2083C14.4918 14.5833 15.1335 14.5833 15.6237 14.3336C16.0549 14.1138 16.4055 13.7633 16.6252 13.3321C16.875 12.8418 16.875 12.2001 16.875 10.9167V6.79167C16.875 5.50821 16.875 4.86649 16.6252 4.37627C16.4055 3.94507 16.0549 3.59449 15.6237 3.37478C15.1335 3.125 14.4918 3.125 13.2083 3.125H6.79167C5.50821 3.125 4.86649 3.125 4.37627 3.37478C3.94507 3.59449 3.59449 3.94507 3.37478 4.37627C3.125 4.86649 3.125 5.50821 3.125 6.79167V11.5278C3.125 12.2382 3.125 12.5934 3.20309 12.8848C3.41499 13.6756 4.0327 14.2933 4.82354 14.5052C5.11496 14.5833 5.47016 14.5833 6.18056 14.5833Z"
        stroke={color}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CommentIcon;
